import { Outlet, Navigate } from "react-router-dom";
import { useAuthStore } from "@/features/auth/stores/authStore";

export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-sidebar-grad p-4">
      <div aria-hidden className="absolute inset-0 bg-argon-mesh opacity-25" />
      <div className="relative w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
